'use client';

import { motion, type Transition, type Variants } from 'motion/react';
import type { ReactNode } from 'react';

// 공용 스크롤 진입 애니메이션 variants (prefers-reduced-motion은 motion이 자동 존중)
export const revealVariants = {
  fadeUp: {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0 },
  },
  fade: {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
  },
} satisfies Record<string, Variants>;

// 트랜지션은 컴포넌트 transition prop으로 직접 전달한다.
// variant 안에 transition을 두면 컴포넌트 transition prop을 덮어써 delay가 누락되므로 분리.
const revealTransitions = {
  fadeUp: { duration: 1.3, ease: 'easeOut' },
  fade: { duration: 1.6, ease: 'easeOut' },
} satisfies Record<keyof typeof revealVariants, Transition>;

interface RevealProps {
  children: ReactNode;
  variant?: keyof typeof revealVariants;
  threshold?: number;
  delay?: number;
  className?: string;
}

export default function Reveal({
  children,
  variant = 'fadeUp',
  threshold = 0.2,
  delay = 0,
  className,
}: RevealProps) {
  return (
    <motion.div
      className={className}
      variants={revealVariants[variant]}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: threshold, margin: '0px 0px -25% 0px' }}
      transition={{ ...revealTransitions[variant], delay }}
    >
      {children}
    </motion.div>
  );
}
